const selector = {
    checkUrl: 'input[name="check_url"]',
    errorUrl: 'input[name="error_url"]',
    data: '#data',
    spiner: '#spinner',
};

export { selector };